
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3.809l9.48 16.38H2.52L12 3.808zM.342 18.929c-.97 1.675.239 3.777 2.178 3.777h18.96c1.94 0 3.148-2.102 2.178-3.777l-9.48-16.38c-.97-1.674-3.387-1.674-4.356 0L.342 18.93zm10.399-8.813v2.518c0 .693.567 1.26 1.259 1.26.693 0 1.259-.567 1.259-1.26v-2.518c0-.692-.566-1.259-1.259-1.259-.692 0-1.259.567-1.259 1.26zm0 6.295h2.518v2.518h-2.518v-2.518z","fill":"currentColor"}})])
          )
        }
      }
    